export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#2C3E3A] py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-4 gap-12 mb-12">
          <div>
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/eaf594fcd34cc7923c4532bd1fc1545e/6ef6c3fac91f2a1905d1aec8ca485dfe.png" 
                alt="少華獎" 
                className="h-12 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              少華獎致力於支持台灣青年發展,讓潛力被看見、讓努力被肯定、讓未來被支持。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-white mb-4 tracking-wider">關於獎項</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('origin')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  獎項緣起
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('core-values')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  核心理念
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('selection')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  評選機制
                </button>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  合作夥伴
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-white mb-4 tracking-wider">申請資訊</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('eligibility')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  申請資格
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('support')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  獎助內容
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('application')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  申請流程
                </button>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  常見問題
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-white mb-4 tracking-wider">聯絡我們</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  聯絡方式
                </button>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  合作提案
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  媒體資源
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  隱私政策
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <p className="text-sm text-gray-400">
              © 2025 台灣青少年才華發展協會
            </p>
            <span className="text-gray-600">|</span>
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
              使用條款
            </a>
            <span className="text-gray-600">|</span>
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
              隱私政策
            </a>
            <span className="text-gray-600">|</span>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>

          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 bg-gray-700 rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-white text-lg w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a href="#" className="w-9 h-9 bg-gray-700 rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-white text-lg w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
